import './styles/epgHeader.scss';
import React from 'react';
import Translator from './../../requests/apa/Translator';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import { Grid, Column, Row, cls } from '../../packages/components';
import { ColoredButton } from '../../packages/components/lib/ColoredButton/';

const EpgHeader = (props) => {
    const config_remote_control =
        DeviceStorage.getItem('config_remote_control') !== 'simple' ? true : false;
    const focusable = 'color-code-item-disabled';
    const classTop = 'epg-header header-top-disabled';
    return (
        <div className={classTop}>
            <div className="epg-header-container">
                <Grid className={cls(`epg_header_grid`)}>
                    <Row className={cls(`epg_header_grid_contenedor`)}>
                        <Column lg={12} className={cls(`epg_header_grid_contenedor-main`)}>
                            <Column lg={6} className={cls(`epg-header-title`)}>
                                <span className={cls(`epg-header-title-span`)}>{props.title}</span>
                            </Column>
                            <Column lg={6} className={cls(`color-codes`)}>
                                <div className={cls(`epg-header-div-colors`)}>
                                    {config_remote_control && (
                                        <ColoredButton
                                            color="yellow"
                                            className={cls(focusable)}
                                            onClick={props && props.yellowHandler}>
                                            {Translator.get('playingLive_fullEpg_option_button_exit', 'SALIR')}
                                        </ColoredButton>
                                    )}
                                    {config_remote_control && (
                                        <ColoredButton
                                            color="blue"
                                            className={cls(focusable)}
                                            onClick={props && props.blueHandler}>
                                            {Translator.get('playingLive_fullEpg_option_button_menuOptions', 'MÁS OPCIONES')}
                                        </ColoredButton>
                                    )}
                                    {config_remote_control && (
                                        <ColoredButton
                                            color="red"
                                            className={cls(focusable)}
                                            onClick={props && props.redHandler}>
                                            {Translator.get('playingLive_fullEpg_option_button_filterSelector', 'FILTRAR')}
                                        </ColoredButton>
                                    )}
                                </div>
                            </Column>
                        </Column>
                    </Row>
                </Grid>
            </div>
        </div>
    );
};

EpgHeader.defaultProps = {
    title: '',
    yellowHandler: null,
    redHandler: null,
    blueHandler: null,
};

export default EpgHeader;



// WEBPACK FOOTER //
// ./src/components/Epg/EpgHeader.jsx